import {
  assignIfExists,
  assignProps,
  findItemByMemberID,
  isValidFilter,
  removeItemByMemberID,
  selectableResult,
} from '@/utils/resultsHelper';
import { responseError } from '@/utils/errors';
import { saveStates, states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import {
  datasetPerms,
  datasetPermsFromArray,
  findDatasetMembers,
  findDatasetPermissions,
  newDatasetMember,
  sharingDatasetState,
} from './state';
import actions, { datasetPermissionGroups, datasetManagePermissions } from '../constants';

const showShareDataset = withDraft((draft, action) => {
  const item = findDatasetPermissions(draft, action);

  draft.sharingDataset.open = true;
  draft.sharingDataset.name = action.name;
  draft.sharingDataset.category = action.category;
  draft.sharingDataset.code = action.code;
  draft.sharingDataset.permissionGroup = item && item[datasetManagePermissions.SECURITY] ? 'OWNER' : 'OBSERVER';
});

const fetchDatasetPermissions = withDraft((draft, action) => {
  const item = findDatasetPermissions(draft, action);

  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.permissions[action.category].results.push({
      code: action.code,
      readErrors: [],
      readStatus: states.PENDING,
      ...datasetPerms(),
    });
  }
});

const showDatasetPermissions = withDraft((draft, action) => {
  const item = findDatasetPermissions(draft, action);

  assignProps(item, {
    ...action.result,
    readErrors: [],
    readStatus: states.SUCCESS,
    ...saveStates,
  });
});

const showDatasetPermissionsError = withDraft((draft, action) => {
  const item = findDatasetPermissions(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const resetShareDataset = withDraft((draft) => { draft.sharingDataset = sharingDatasetState(); });

const updateShareDatasetProperties = withDraft((draft, action) => {
  assignIfExists(draft.sharingDataset, action.properties);
});

const shareDataset = withDraft((draft) => { draft.sharingDataset.saveStatus = states.PENDING; });

const updateDatasetMembersProperties = withDraft((draft, action) => {
  assignIfExists(findDatasetMembers(draft, action), action.properties);
});

const fetchDatasetMembers = withDraft((draft, action) => {
  const members = findDatasetMembers(draft, action);
  members.filter = action.filter;
  members.results = [];
  members.readStatus = isValidFilter(action.filter, members) ? states.PENDING : states.NONE;
  members.readErrors = [];
});

const showDatasetMembers = withDraft((draft, action) => {
  const members = findDatasetMembers(draft, action);
  const results = action.results.map(selectableResult);
  members.readStatus = states.SUCCESS;
  members.readErrors = [];
  members.results = results;
  members.original = results;
  members.count = action.resultsCount;
});

const showDatasetMembersError = withDraft((draft, action) => {
  const members = findDatasetMembers(draft, action);
  members.readStatus = states.ERROR;
  members.readErrors = [responseError(action)];
});

const addDatasetMembers = withDraft((draft) => {
  const perms = datasetPermsFromArray(datasetPermissionGroups[draft.sharingDataset.permissionGroup]);
  const membersToAdd = draft.sharingDataset.membersToAdd.map((member) => newDatasetMember(member, perms));
  draft.sharingDataset.membersToAdd = [];
  draft.sharingDataset.members.results = draft.sharingDataset.members.results.concat(membersToAdd);
  draft.sharingDataset.unassignedMembers.filter = '';
});

const removeDatasetMember = withDraft((draft, action) => {
  draft.sharingDataset.members.results = removeItemByMemberID(
    draft.sharingDataset.members.results,
    action.memberID,
  );
});

const updateDatasetMemberPermissions = withDraft((draft, action) => {
  const member = findItemByMemberID(draft.sharingDataset.members.results, action.memberID);
  member.permissions = datasetPermsFromArray(datasetPermissionGroups[action.permissions]);
});

export default {
  [actions.ADD_DATASET_MEMBERS]: addDatasetMembers,
  [actions.FETCH_DATASET_MEMBERS]: fetchDatasetMembers,
  [actions.FETCH_DATASET_PERMISSIONS]: fetchDatasetPermissions,
  [actions.HIDE_SHARE_DATASET]: resetShareDataset,
  [actions.REMOVE_DATASET_MEMBER]: removeDatasetMember,
  [actions.SHARE_DATASET]: shareDataset,
  [actions.SHARE_DATASET_ERROR]: resetShareDataset,
  [actions.SHARE_DATASET_SUCCESS]: resetShareDataset,
  [actions.SHOW_DATASET_MEMBERS]: showDatasetMembers,
  [actions.SHOW_DATASET_MEMBERS_ERROR]: showDatasetMembersError,
  [actions.SHOW_DATASET_PERMISSIONS]: showDatasetPermissions,
  [actions.SHOW_DATASET_PERMISSIONS_ERROR]: showDatasetPermissionsError,
  [actions.SHOW_SHARE_DATASET]: showShareDataset,
  [actions.UPDATE_DATASET_MEMBER_PERMISSIONS]: updateDatasetMemberPermissions,
  [actions.UPDATE_DATASET_MEMBERS_PROPERTIES]: updateDatasetMembersProperties,
  [actions.UPDATE_SHARE_DATASET_PROPERTIES]: updateShareDatasetProperties,
};
